<template>
  <main>
    <header>
      <div id="post_list"
        v-touch:swipe="swipeHandler"
        class="post_wrapper"  :class="firstLoad && pagesCurr ? 'opened' : 'closed'">
        <transition name="slide-down" mode="out-in">
          <div :key="type">
          <transition :name="slide" mode="out-in">
            <ul :key="pagesCurr">
              <li v-for="post in posts" :class="post.categories[0] | cat2name">
                <router-link :class="post.id === postsSelected.id ? 'selected' : ''" :to="{path:'/'+type+'/'+post.slug,meta:{type:type}}" v-html="post.title.rendered"></router-link>
                <small>{{post.date | shortDate}}
                  <strong :title="'autor: '+post.author_meta[0]" @click="searchAuthor(post.author_meta[0]);" :style="post.author_meta[1] | formatImg"></strong></small>
              </li>
            </ul>
          </transition>
          </div>
        </transition>
      </div>
      <nav v-if="pagesCurr">
        <span><a class="larr" @click="changePage(-1)" v-show="pagesCurr != 1" title="Mais antigos">
          <svg height="20" width="30" viewBox="0 0 30 20">
              <polygon points="
                16,20
                0,10
                16,0"/>
              <polygon points="
                31,20
                15,10
                31,0"/>
          </svg>
        </a></span>
        <small><strong>{{pagesCurr}}</strong> / <a @click="changePage(pagesTotal)">{{pagesTotal}}</a></small>
        <span><a class="rarr" @click="changePage(1)" v-show="pagesCurr != pagesTotal" title="Mais recentes">
          <svg height="20" width="30" viewBox="0 0 30 20">
              <polygon points="
                0,20
                16,10
                0,0"/>
              <polygon points="
                15,20
                30,10
                15,0"/>
          </svg>
        </a></span>
      </nav>
      <span v-if="!isHome()" v-ornament></span>
    </header>
  </main>
  </transition>
</template>

<script>
import Axios from 'axios';
export default {
  name: 'Sidebar',
  props: ['type','searchTerm'],
  data () {
    return {
      slide: '',
      term: '',
      firstLoad: false
    }
  },
  watch: {
    'type': {
      handler(now,next){
        if(this.type){
          if(this.type != 'search') {
            this.term = undefined;
            this.$store.commit('clearSearch');
          }
          else {
            this.term = this.searchTerm;
          }
          this.$store.dispatch('initPosts',this.type);
          this.firstLoad = true;
        }
      }
    },
    'searchTerm': {
      handler() {
        this.term = this.searchTerm
      }
    }
  },
  computed: {
    posts() {
      if(this.$store.getters.getPosts[this.type]) {
        if(this.$store.getters.getPosts[this.type][this.$store.getters.getPagesCurr]) {
          return this.$store.getters.getPosts[this.type][this.$store.getters.getPagesCurr];
        }
      }
    },
    postsSelected() {
      let post = {
        id: ''
      };
      if(this.$store.getters.getPostsSelected) {
        post = this.$store.getters.getPostsSelected;
      }
      return post;
    },
    pagesTotal() {
      return this.$store.getters.getPagesTotal[this.type];
    },
    pagesCurr() {
      if(!this.$store.getters.getPagesCurr ) {
        this.firstLoad = false;
      }
      else {
        this.firstLoad = true;
      }
      return this.$store.getters.getPagesCurr;
    }
  },
  mounted() {
    //this.$store.dispatch('initPosts')
  },
  methods: {
    swipeHandler(direction) {
      if(direction == 'left') {
        if(this.$store.getters.getPagesCurr + 1 > this.$store.getters.getPagesTotal[this.type]) {
          return;
        }
        this.changePage(1)
      } else {
        if(this.$store.getters.getPagesCurr - 1 === 0) {
          return;
        }
        this.changePage(-1)
      }
    },
    isHome() {
      if(this.$route.name == 'home' || this.$route.name == 'sobre') {
        return true;
      }
    },
    changePage(dir) {
      if(dir>0) {
        this.slide = 'slide-left';
      }
      else {
        this.slide = 'slide-right';
      }
      this.$store.dispatch('changePagesCurr',[this.type,dir,this.term])
    },
    searchAuthor(author){
      this.$store.dispatch('setSearch','autor:'+author)
    }
  },
  filters: {
    shortDate(str) {
      return str.substring(0, 10).split('-').reverse().join('/');
    },
    cat2name(cat) {
      if(cat == 5) {
        return 'poesia';
      }
      else {
        return 'prosa'
      }
    }
  }
}
</script>

<style scoped>
.opened {
  max-height: 300px
}
.closed {
  max-height: 0
}
header {
  /*max-width: 300px*/
}
h2 {
  font-size: 1.8em
}
ul {
  font-size: 1.5em;
}
small {
  color: #a1a1a1;
  margin: auto
}
nav {
  margin-top: 10px;
  display: flex
}
nav>* {
  flex: 1;
  text-align: right
}
nav>small {
  text-align: center;
}
nav>:first-child {
  text-align: left
}
nav>span>a:hover {
  color: rgb(var(--yellow));
}
nav>span>a {
  letter-spacing: -3px;
  font-size: 1.3em
}
nav>span>a>svg {
  height: 10px;
  width: auto;
  fill: rgb(var(--red));
}
.larr::after {
  /*content: '\25c0\25c0';*/
}
.rarr::after {
  /*padding-right: 2px;
  content: '\25b6\25b6';*/
}

ul, .post_wrapper {
  transition: all 200ms;
  height: 300px;
  overflow: hidden;
}
li {
  height: 26px;
  margin-bottom: 4px;
  box-sizing: border-box;
  display: flex;
  transition: all 200ms;
  max-width: 100%;
  overflow: hidden;
}
li>a {
  transition: all 200ms;
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 20px;
  display: block;
  width: 100%;
  max-width: 200px;
  line-height: 20px;
  box-sizing: border-box;
}
li>a::before {
  content: '';
  display: inline-block;
  width: 5px;
  height: 20px;
  background: red;
  transition: all 200ms;
  margin-right: 5px;
  vertical-align: bottom;
  line-height: 20px
}
li a:hover::before{
  width: 10px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
li a.selected::before {
  width: 20px;
  border-radius: 50%
}
li:hover a.selected{
}
li>small {
  line-height: 20px;
  white-space: nowrap;
  margin-right: 0;
}
li>small>strong {
  font-family: sans-serif;
  display: inline-flex;
  text-transform: uppercase;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 10px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  line-height: 16px;
  text-align: center;
  box-sizing: border-box;
  line-height: 20px;
  cursor: pointer;
  vertical-align: text-bottom;
  /*font-weight: normal;*/
  background-size: contain;
  background-position: center center;
  border: 1px solid rgb(var(--dgray));
  transition: color 200ms, background-color 200ms
}
li>small>strong:hover {
  color: white;
  background-color: rgb(var(--dgray));
}
.poesia a::before {
  background: rgb(var(--yellow));
}
.poesia {
  border-bottom: 1px dotted rgb(var(--yellow));
}
.prosa>a::before {
  background: rgb(var(--red));
}
.prosa {
  border-bottom: 1px dotted rgb(var(--red));
}
.prosa>a,.poesia>a  {
  color: rgb(var(--dgray)) !important;
  text-decoration: none
}
main{
  overflow: hidden;
  transition: all 200ms
}

</style>



// WEBPACK FOOTER //
// src/components/Postlist.vue